<template>
    <main class="flex flex-col bg-gray-50">
        <div class="mt-6 sm:mt-10 mb-6">
            <img
                src="@/assets/images/header/fubonLogo.svg"
                alt="富邦人壽|線上交易"
                class="w-36 h-[1.875rem] mx-auto"
            >
        </div>
        <div class="rounded-t-md rounded-b-lg bg-white pb-[2.5rem] overflow-hidden w-[92%] sm:w-4/5 max-w-[80.5rem] mx-auto shadow-1 border border-gray-100">
            <div class="h-2.5 gradient-primary mb-6" />
            <!-- 主/次標題 -->
            <div
                v-if="$route.meta.pageTitle"
                class="text-[1.5rem] text-primary text-center px-4"
            >
                {{ $route.meta.pageTitle }}
            </div>
            <div
                v-if="$route.meta.subtitle"
                class="text-gray-400 text-sm md:text-base text-center pt-1 px-4"
            >
                {{ $route.meta.subtitle }}
            </div>
            <div class="border-t w-[85%] max-w-[70rem] mx-auto mt-6 pt-6">
                <router-view />
            </div>
        </div>
        <CountDown v-if="$route.name!==routeName.ENOTIFY && $route.name!==routeName.PDF_TERMS" />
    </main>
    <FooterLayout />
</template>

<script>
import CountDown from '@/components/dialogs/PopupCountDown.vue';
import routeName from '@/router/constant.js';
import FooterLayout from '@/components/layout/Footer.vue';

export default {
    components: {
        CountDown,
        FooterLayout,
    },
    setup() {
        return {
            routeName
        };
    },
};
</script>
